module.exports = __webpack_public_path__ + "img/logoIFluks.30b7b0bf.jpg";